import { Platform } from 'react-native';
import useFeatureGate from '../framework/useFeatureGate';
const STEP_UP_AUTHENTICATION_IOS_FEATURE_ID = 'AtoZMobile:StepUpAuthenticationiOS';
const STEP_UP_AUTHENTICATION_ANDROID_FEATURE_ID = 'AtoZMobile:StepUpAuthenticationAndroid';
export const STEP_UP_AUTHENTICATION_FEATURE_ID = Platform.select({
    ios: STEP_UP_AUTHENTICATION_IOS_FEATURE_ID,
    android: STEP_UP_AUTHENTICATION_ANDROID_FEATURE_ID,
    default: undefined,
});
export const useStepUpAuthEnabled = () => (!!STEP_UP_AUTHENTICATION_FEATURE_ID && useFeatureGate(STEP_UP_AUTHENTICATION_FEATURE_ID));
//# sourceMappingURL=index.js.map